import React, { useEffect, useState } from "react";
import {
    useCreateItemMutation,
    useSingleItem,
    useUpdateItemMutation,
} from "../../actions/app/items";
import log from "cslog";
import cloneDeep from "lodash/cloneDeep";
import { Dropdown, Popconfirm, Tooltip } from "antd";
import { DownOutlined, UserOutlined } from "@ant-design/icons";
import { CREATOR_BASE_URL } from "../../constants";
import { getEditURL, getEditURLDev, getViewerURL } from "../../_helpers/editor";
import { nanoid } from "nanoid";

const CREATOR_URL = CREATOR_BASE_URL;

function ItemOptionMenu({ children, item }) {
    const [clone, setClone] = useState(false);
    const { isSuccess, isLoading, data } = useSingleItem(
        "qp_creation",
        `/${item.id}?fields=*,used_schemas.*`,
        clone
    );
    const createMutation = useCreateItemMutation();
    const updateMutation = useUpdateItemMutation();

    useEffect(() => {
        if (clone) {
            if (isSuccess && data) {
                let newData = cloneDeep(data);
                newData = {
                    ...newData,
                    title: `Copy of ${newData?.title}`,
                    slug: `${newData?.slug}_copy_${nanoid(5)}`,
                };
                delete newData["id"];
                delete newData["date_created"];
                delete newData["date_updated"];
                delete newData["published_creation"];
                delete newData["preview"];
                delete newData["comments"];
                delete newData["templates"];

                const new_used_schemas = [];
                newData.used_schemas.forEach((item) => {
                    new_used_schemas.push({
                        qdb_creation_schema_id: item.qdb_creation_schema_id,
                    });
                });
                newData = {
                    ...newData,
                    used_schemas: new_used_schemas,
                };

                let out = {
                    collection: "qp_creation",
                    data: newData,
                };
                log.h3("Cloning Req Sending...");
                log.d(out, "Final Data");
                createMutation.mutate(out);
                setClone(false);
            }
        }
    }, [clone, isSuccess, data]);

    const archiveItem = () => {
        log.p("Archiving....");
        const out = {
            collection: "qp_creation",
            id: item.id,
            data: {
                archived: true,
            },
        };
        updateMutation.mutate(out);
    };

    const menuItems = [
        {
            key: "edit",
            icon: <UserOutlined />,
            label: (
                <a
                    href={getEditURLDev(item.id)}
                    target="_blank"
                    rel="noreferrer"
                >
                    Edit
                </a>
            ),
        },
        {
            key: "duplicate",
            icon: <UserOutlined />,
            label: "Duplicate",
            onClick: () => setClone(true),
        },
        {
            key: "view",
            icon: <UserOutlined />,
            label: (
                <a
                    href={getViewerURL(item.slug, item.type === "website")}
                    target="_blank"
                    rel="noreferrer"
                >
                    View
                </a>
            ),
        },
        {
            key: "delete",
            icon: <UserOutlined />,
            danger: true,
            label: (
                <Popconfirm
                    title="Are you sure?"
                    placement="topRight"
                    okText="Delete"
                    onConfirm={archiveItem}
                >
                    <span>Move to trash</span>
                </Popconfirm>
            ),
        },
    ];

    return (
        <Dropdown
            menu={{ items: menuItems }}
            placement="topRight"
            styles={{
                root: { boxShadow: "0px 0px 5px 0px rgba(186,186,186,1)" },
            }}
        >
            {children}
        </Dropdown>
    );
}

export default ItemOptionMenu;
